<template>
	<div class="container_page">
		<div>品牌详情</div>
		<!--  -->
		<div>品牌详情</div>
		<!--  -->
		<div>品牌详情</div>
		<!--  -->
	</div>
</template>
<script>
	import {
		// cardListCardsApi,
		// cardListCardsAddApi,
		// cardListCardsDelApi,
		getOssAuth,
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {

			};
		},
		created() { 
			// 获取路由里的工厂id
			const factoryId = this.$route.params.id;
		},
		activated() {},
	};
</script>
<style lang="less">
</style>